import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import nimiLogo from "../assets/logo.png";
import { getBootstrapData } from '../utils/market';
import { useLocales } from '../locales';

const PowerdByNimi = () => {
    const { translate } = useLocales();
    // if isWhiteLabel is true, then the logo is white then hide this.
    const { whiteLabel, poweredBy } = getBootstrapData() ?? {};
    if (whiteLabel) {
        return null;
    }
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                padding: 2,
            }}
        >
            <Typography
                sx={{
                    color: 'rgba(0, 0, 0, 0.6)',
                    fontSize: '14px',
                    margin: 0,
                }}
            >
                {translate('powered_by')}
            </Typography>

            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                }}
            >
                <Box
                    component="img"
                    src={nimiLogo}
                    alt="Nimi Logo"
                    sx={{
                        height: 24,
                        width: 'auto',
                    }}
                />
            </Box>

            <Link
                href={poweredBy?.url ?? "https://nimi.co.il" }
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                    color: 'rgba(0, 0, 0, 0.6)',
                    textDecoration: 'none',
                    fontSize: '14px',
                    transition: 'color 0.2s ease',
                    '&:hover': {
                        color: 'rgba(0, 0, 0, 0.8)',
                    },
                }}
            >
                {poweredBy?.name ?? "nimi.co.il"}
            </Link>
        </Box>
    );
};

export default PowerdByNimi;
